import { useLanguage } from '../../context/LanguageContext';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const TABS = [
  {
    id: 'customer',
    labelKey: 'customerPortal',
    labelIcon: '🛍️',
    color: '#B91C1C',
    activeBg: '#B91C1C',
    roles: [
      {
        key: 'customer', labelKey: 'customer', subtitleKey: 'shopper', icon: '🛍️', color: '#B91C1C',
        descKey: 'customerDesc',
        loginUrl: '/login',
      },
      {
        key: 'affiliate', labelKey: 'affiliatePartner', subtitleKey: 'referralPartner', icon: '🤝', color: '#D97706',
        descKey: 'affiliateDesc',
        loginUrl: '/login',
      },
    ],
  },
  {
    id: 'merchant',
    labelKey: 'merchantPortal',
    labelIcon: '🏪',
    color: '#059669',
    activeBg: '#059669',
    roles: [
      {
        key: 'merchant', labelKey: 'roleMerchant', subtitleKey: 'roleMerchantSub', icon: '🏪', color: '#059669',
        descKey: 'roleMerchantDesc',
        loginUrl: '/merchant/login',
      },
      {
        key: 'merchant_staff', labelKey: 'roleMerchantStaff', subtitleKey: 'roleMerchantStaffSub', icon: '👥', color: '#0284C7',
        descKey: 'roleMerchantStaffDesc',
        loginUrl: '/merchant/login',
      },
    ],
  },
  {
    id: 'operations',
    labelKey: 'operationsPortal',
    labelIcon: '🛡️',
    color: '#4338CA',
    activeBg: '#1E293B',
    roles: [
      { key: 'admin', labelKey: 'roleAdmin', subtitleKey: 'roleAdminSub', icon: '⚙️', color: '#7C3AED', descKey: 'roleAdminDesc', loginUrl: '/admin/admin_login' },
      { key: 'support', labelKey: 'roleSupport', subtitleKey: 'roleSupportSub', icon: '🎧', color: '#0891B2', descKey: 'roleSupportDesc', loginUrl: '/admin/support_login' },
      { key: 'delivery', labelKey: 'roleDelivery', subtitleKey: 'roleDeliverySub', icon: '🚚', color: '#EA580C', descKey: 'roleDeliveryDesc', loginUrl: '/admin/delivery_login' },
      { key: 'warehouse', labelKey: 'roleWarehouse', subtitleKey: 'roleWarehouseSub', icon: '📦', color: '#65A30D', descKey: 'roleWarehouseDesc', loginUrl: '/admin/warehouse_login' },
      { key: 'finance', labelKey: 'roleFinance', subtitleKey: 'roleFinanceSub', icon: '💰', color: '#16A34A', descKey: 'roleFinanceDesc', loginUrl: '/admin/finance_login' },
      { key: 'moderator', labelKey: 'roleModerator', subtitleKey: 'roleModeratorSub', icon: '🔍', color: '#9333EA', descKey: 'roleModeratorDesc', loginUrl: '/admin/moderator_login' },
      { key: 'returns_manager', labelKey: 'roleReturns', subtitleKey: 'roleReturnsSub', icon: '🔄', color: '#DC2626', descKey: 'roleReturnsDesc', loginUrl: '/admin/returns_login' },
      { key: 'marketing', labelKey: 'roleMarketing', subtitleKey: 'roleMarketingSub', icon: '📣', color: '#E11D48', descKey: 'roleMarketingDesc', loginUrl: '/admin/marketing_login' },
      { key: 'catalog_manager', labelKey: 'roleCatalog', subtitleKey: 'roleCatalogSub', icon: '📋', color: '#0D9488', descKey: 'roleCatalogDesc', loginUrl: '/admin/catalog_login' },
      { key: 'vendor_onboarding', labelKey: 'roleVendor', subtitleKey: 'roleVendorSub', icon: '🤝', color: '#7C3AED', descKey: 'roleVendorDesc', loginUrl: '/admin/onboarding_login' },
      { key: 'ad_manager', labelKey: 'roleAdManager', subtitleKey: 'roleAdManagerSub', icon: '🎯', color: '#BE185D', descKey: 'roleAdManagerDesc', loginUrl: '/admin/ads_login' },
      { key: 'community_manager', labelKey: 'roleCommunity', subtitleKey: 'roleCommunitySub', icon: '🌐', color: '#2563EB', descKey: 'roleCommunityDesc', loginUrl: '/admin/community_login' },
      { key: 'dispute_arbitrator', labelKey: 'roleDispute', subtitleKey: 'roleDisputeSub', icon: '⚖️', color: '#B45309', descKey: 'roleDisputeDesc', loginUrl: '/admin/disputes_login' },
      { key: 'qa_tester', labelKey: 'roleQA', subtitleKey: 'roleQASub', icon: '✅', color: '#15803D', descKey: 'roleQADesc', loginUrl: '/admin/qa_login' },
      { key: 'regional_manager', labelKey: 'roleRegional', subtitleKey: 'roleRegionalSub', icon: '🗺️', color: '#4338CA', descKey: 'roleRegionalDesc', loginUrl: '/admin/regional_login' },
      { key: 'api_partner', labelKey: 'roleAPI', subtitleKey: 'roleAPISub', icon: '🔑', color: '#1E293B', descKey: 'roleAPIDesc', loginUrl: '/admin/api_login' },
    ],
  },
];

const ChooseRolePage = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('customer');
  const navigate = useNavigate();
  const currentTab = TABS.find(t => t.id === activeTab);

  const handleRoleClick = (role) => {
    navigate(role.loginUrl);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FFF7ED 0%, #FEF2F2 30%, #EFF6FF 70%, #F0FDF4 100%)' }}>
      <div style={{ padding: '24px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <span style={{ fontSize: '28px', fontWeight: 800, color: '#B91C1C', fontFamily: "'Poppins', sans-serif" }}>
            eBuy<span style={{ color: '#EAB308' }}>Wiz</span>
          </span>
        </Link>
        <span style={{ fontFamily: "'Playfair Display', serif", color: '#B91C1C', fontSize: '18px', fontStyle: 'italic' }}>
          {t('multiVendorMarketplace')}
        </span>
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 24px 60px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '36px', fontWeight: 700, color: '#1F2937', marginBottom: '8px' }}>
            {t('signInToEbuywiz')}
          </h1>
          <p style={{ color: '#6B7280', fontSize: '16px', marginBottom: '6px' }}>{t("chooseRole")}</p>
          <p style={{ color: '#6B7280', fontSize: '14px' }}>
            {t("dontHaveAccount")}{' '}
            <Link to="/register" style={{ color: '#B91C1C', fontWeight: 600, textDecoration: 'none' }}>{t("signUpDot")}</Link>
          </p>
        </div>

        {/* Portal Tabs */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '36px' }}>
          {TABS.map(tab => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '14px 28px', borderRadius: '12px',
                  border: isActive ? 'none' : `2px solid ${tab.color}25`,
                  background: isActive ? tab.activeBg : '#FFFFFF',
                  color: isActive ? '#FFFFFF' : tab.color,
                  fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                  transition: 'all 0.3s ease', fontFamily: "'Poppins', sans-serif",
                  letterSpacing: '0.3px',
                  boxShadow: isActive ? `0 8px 24px ${tab.color}30` : '0 2px 8px rgba(0,0,0,0.04)',
                  transform: isActive ? 'scale(1.02)' : 'scale(1)',
                }}
                onMouseEnter={(e) => { if (!isActive) { e.currentTarget.style.borderColor = `${tab.color}50`; e.currentTarget.style.background = `${tab.color}08`; } }}
                onMouseLeave={(e) => { if (!isActive) { e.currentTarget.style.borderColor = `${tab.color}25`; e.currentTarget.style.background = '#FFFFFF'; } }}
              >
                {tab.labelKey ? `${tab.labelIcon} ${t(tab.labelKey)}` : tab.label}
              </button>
            );
          })}
        </div>

        <p style={{ textAlign: 'center', fontSize: '13px', color: '#9CA3AF', marginBottom: '24px' }}>
          {t('rolesAvailable', { count: currentTab.roles.length })}
        </p>

        {/* Role Cards Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: currentTab.roles.length <= 2
            ? 'repeat(2, minmax(0, 420px))'
            : 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: '16px', justifyContent: 'center',
        }}>
          {currentTab.roles.map((role) => (
            <div
              key={role.key}
              onClick={() => handleRoleClick(role)}
              style={{
                background: '#FFFFFF', borderRadius: '16px',
                padding: currentTab.roles.length <= 2 ? '36px 28px' : '28px 22px',
                cursor: 'pointer', transition: 'all 0.3s ease',
                border: '2px solid transparent', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = `0 12px 32px ${role.color}20`;
                e.currentTarget.style.borderColor = `${role.color}40`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <div style={{
                width: currentTab.roles.length <= 2 ? '72px' : '58px',
                height: currentTab.roles.length <= 2 ? '72px' : '58px',
                borderRadius: '20px', background: `${role.color}10`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: currentTab.roles.length <= 2 ? '36px' : '28px', marginBottom: '14px',
              }}>
                {role.icon}
              </div>
              <h3 style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: currentTab.roles.length <= 2 ? '15px' : '13px',
                fontWeight: 700, color: role.color, letterSpacing: '0.5px', marginBottom: '3px',
              }}>
                {role.labelKey ? t(role.labelKey) : role.label}
              </h3>
              <span style={{ fontSize: '12px', color: '#9CA3AF', marginBottom: '10px' }}>{role.subtitleKey ? t(role.subtitleKey) : role.subtitle}</span>
              <p style={{
                fontSize: currentTab.roles.length <= 2 ? '14px' : '12px',
                color: '#6B7280', lineHeight: 1.5, marginBottom: '16px', flexGrow: 1,
              }}>
                {role.descKey ? t(role.descKey) : role.desc}
              </p>
              <button style={{
                background: role.color, color: '#FFF', border: 'none',
                padding: '10px 24px', borderRadius: '8px', fontSize: '12px',
                fontWeight: 700, cursor: 'pointer', textTransform: 'uppercase',
                letterSpacing: '0.5px', width: '100%', fontFamily: "'Poppins', sans-serif",
              }}>
                {role.labelKey ? t(role.labelKey) : role.label}
              </button>
            </div>
          ))}
        </div>

        {activeTab === 'operations' && (
          <div style={{
            textAlign: 'center', marginTop: '28px', padding: '16px 24px',
            background: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0',
          }}>
            <p style={{ color: '#64748B', fontSize: '13px', margin: 0 }}>
              🔒 {t('opsAccountsCreatedFull')}
            </p>
          </div>
        )}
      </div>

      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&family=Playfair+Display:ital,wght@0,700;1,700&display=swap" rel="stylesheet" />
    </div>
  );
};

export default ChooseRolePage;
